import { storageKeyVoice } from "../../../model/StorageKeys";
import storeState from "../../../utils/storeState";
import { ActionType } from "../../Actions";
import { VOICE_CHANGE } from "../../Actions/Kiosk/voiceChangeAction";
import { KioskStateType } from "../../KioskReducer";

export default function voiceReducer(
  state: KioskStateType,
  action: ActionType
) {
  switch (action.type) {
    case VOICE_CHANGE:
      storeState(storageKeyVoice, action.payload);
      return {
        ...state,
        voice: action.payload,
      };
  }
}
